<div class="container config-widget" [ngClass]="{'visible':languageLoaded}">
    <div *ngIf="(!isCustomerVersion()) && moduleAvailable('devices') && subModuleAvailable('devices','vrc720f')"  class="row tab-row">
        <div class="container tab-container underlined">
            <div class="md-12">
                <div class="tab" 
                [ngClass]="{'selected':cfg.isVariant('vrc720')}"
                (click)="getSimulatorConfig().setVariant('vrc720')">
                    <div class="tab-content">VRC 720/2</div>
                </div>
            
                <div class="tab" 
                [ngClass]="{'selected':cfg.isVariant('vrc720f')}"
                (click)="getSimulatorConfig().setVariant('vrc720f')">
                    <div class="tab-content">VRC 720f/2</div>
                </div>
            </div>

        </div>
    </div>
    

    <div *ngIf="isCustomerVersion() && moduleAvailable('devices') && ( subModuleAvailable('devices','vrc720f') || subModuleAvailable('devices','vrc720'))"  class="row tab-row">
        <div class="container tab-container underlined">
            <div class="md-12">
                <div *ngIf="subModuleAvailable('devices','vrc720')" class="tab selected" 
                [ngClass]="{'selected':cfg.isVariant('vrc720')}"
                (click)="getSimulatorConfig().setVariant('vrc720')">
                    <div class="tab-content">sensoCOMFORT</div>
                </div>
            
                <div *ngIf="subModuleAvailable('devices','vrc720f')" class="tab" 
                [ngClass]="{'selected':cfg.isVariant('vrc720f')}"
                (click)="getSimulatorConfig().setVariant('vrc720f')">
                    <div class="tab-content">sensoCOMFORT f</div>
                </div>
            </div>

        </div>
    </div>
    <div class="row">

            <!-- Endkunden-Varianten -->
            <div *ngIf="(isCustomerVersion())" class="config-section col-xl-4 col-md-6 col-12 no-icon">
            <div class="container"> 
                <div class="row">

                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span><!-- no title --></span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">


                        <form [formGroup]="customerChoiceForm">

                            <div class="form-row">
                                <div class="col-1"><input type="radio" value="boiler" formControlName="customerChoice" [attr.disabled]='isDisabled("customerChoice","boiler")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("customerChoice","heatpump")}'>{{getTranslator().tr('CONFIG_UI_CAPTION_BOILER')}}</label>
                            </div>

                            <div class="form-row">
                                <div class="col-1"><input type="radio" value="heatpump" formControlName="customerChoice" [attr.disabled]='isDisabled("customerChoice","heatpump")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("custmerChoice","heatpump")}'>{{getTranslator().tr('CONFIG_UI_CAPTION_HEATPUMP')}}</label>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>
        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('boiler')" class="config-section col-xl-4 col-md-6 col-12 boiler">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_BOILER')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">
                        <form [formGroup]="boilerForm">
                            <div class="form-row" *ngIf="subModuleAvailable('boiler','no')">
                                <div class="col-1"><input type="radio" value="no" formControlName="useBoiler" [attr.disabled]='isDisabled("useBoiler","no")'></div>
                                <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("useBoiler","no")}'>{{getTranslator().tr('CONFIG_UI_NO')}}</label>
                            </div>
                            
                            <div class="form-row" *ngIf="subModuleAvailable('boiler','yes')">
                                <div class="col-1"><input type="radio" value="yes" formControlName="useBoiler" [attr.disabled]='isDisabled("useBoiler","yes")'></div>
                                <label class="col-4" [ngClass]='{"disabled":isDisabled("useBoiler","yes")}'>{{getTranslator().tr('CONFIG_UI_YES')}}</label>
                                <div class="col-7 col-xl-3">
                                    <select (click)="this.boilerForm.get('useBoiler').setValue('yes')" class="form-control xs-8 btn" formControlName="boilerNumber" [attr.disabled]='isDisabled("boilerNumber","")' [ngStyle]="{'width':'auto'}">
                                        <option *ngFor='let num of [1,2,3,4,5,6,7]' [attr.disabled]='isDisabled("boilerNumber",num)' [value]="num">{{num}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('boiler','ecoTecExclusive')">
                                <div class="col-1"><input type="radio" value="ecoTecExclusive" formControlName="useBoiler" [attr.disabled]='isDisabled("useBoiler","ecoTecExclusive")'></div>
                                <label class="col-4" [ngClass]='{"disabled":isDisabled("useBoiler","ecoTecExclusive")}'>ecoTEC exclusive</label>
                                <div class="col-7 col-xl-3">
                                    <select class="form-control xs-8 btn" formControlName="ecoTecNumber" [attr.disabled]='isDisabled("ecoTecNumber","")' (click)='this.boilerForm.get("useBoiler").setValue("ecoTecExclusive")' [ngStyle]="{'width':'auto'}">
                                        <option *ngFor='let num of [1,2,3,4,5,6,7]' [value]="num" [attr.disabled]='isDisabled("ecoTecNumber",num)'>{{num}}</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <hr/>
        </div>
        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('heatPump')" class="config-section col-xl-4 col-md-6 col-12 heat-pump">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_HEATPUMP')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">


                        <form [formGroup]="heatPumpForm">

                            <div class="form-row" *ngIf="subModuleAvailable('heatPump','no')">
                                <div class="col-1"><input type="radio" value="no" formControlName="useHeatPump" [attr.disabled]='isDisabled("useHeatPump","no")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("useHeatPump","no")}'>{{getTranslator().tr('CONFIG_UI_NO')}}</label>
                            </div>

                            <div class="form-row"  *ngIf="subModuleAvailable('heatPump','aroTherm')">
                                <div class="col-1"><input type="radio" value="aroTherm" formControlName="useHeatPump" [attr.disabled]='isDisabled("useHeatPump","aroTherm")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("useHeatPump","aroTherm")}'>aroTHERM / aroTHERM split</label>
                                <div class="col-7 col-md-4">
                                    <select [attr.disabled]='isDisabled("useHeatPump","aroTherm")' class="form-control xs-8 btn" formControlName="aroThermNumber" (click)='this.heatPumpForm.get("useHeatPump").setValue("aroTherm")' [ngStyle]="{'width':'auto'}">
                                        <option *ngFor='let num of [1,2,3,4,5,6,7]' [value]="num" [attr.disabled]='isDisabled("aroThermNumber",num)'>{{num}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('heatPump','flexoTherm')">
                                <div class="col-1"><input type="radio" value="flexoTherm" formControlName="useHeatPump"  [attr.disabled]='isDisabled("useHeatPump","flexoTherm")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("useHeatPump","flexoTherm")}'>flexoTHERM / flexoCOMPACT</label>
                                <div class="col-7 col-md-4">
                                    <select class="form-control xs-8 btn" formControlName="flexoThermNumber" [attr.disabled]='isDisabled("useHeatPump","flexoTherm")' (click)='this.heatPumpForm.get("useHeatPump").setValue("flexoTherm")' [ngStyle]="{'width':'auto'}">
                                        <option *ngFor='let num of [1,2,3,4,5,6,7]' [value]="num" [value]="num" [attr.disabled]='isDisabled("flexoThermNumber",num)'>{{num}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-row" *ngIf="subModuleAvailable('heatPump','geoTherm')">
                                <div class="col-1"><input type="radio" value="geoTherm" formControlName="useHeatPump" [attr.disabled]='isDisabled("useHeatPump","geoTherm")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("useHeatPump","geoTherm")}'>geoTHERM 3 kW</label>
                            </div>


                            <div class="form-row" *ngIf="subModuleAvailable('heatPump','versoTherm')">
                                <div class="col-1"><input type="radio" value="versoTherm" formControlName="useHeatPump" [attr.disabled]='isDisabled("useHeatPump","versoTherm")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("useHeatPump","versoTherm")}'>versoTHERM</label>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('heatPump','recoCompact')">
                                <div class="col-1"><input type="radio" value="recoCompact" formControlName="useHeatPump" [attr.disabled]='isDisabled("useHeatPump","recoCompact")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("useHeatPump","recoCompact")}'>recoCOMPACT</label>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>
        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('ventilation')" class="config-section col-xl-4 col-md-6 col-12 ventilation-system">
            <div class="container"> 
                <div class="row">

                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_VENTILATION')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">


                        <form [formGroup]="ventilationForm">

                            <div class="form-row">
                                <div class="col-1"><input type="radio" value="no" formControlName="ventilation" [attr.disabled]='isDisabled("ventilation","no")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("ventilation","no")}'>{{getTranslator().tr('CONFIG_UI_NO')}}</label>
                            </div>

                            <div class="form-row">
                                <div class="col-1"><input type="radio" value="yes" formControlName="ventilation" [attr.disabled]='isDisabled("ventilation","yes")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("ventilation","yes")}'>{{getTranslator().tr('CONFIG_UI_YES')}}</label>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>


        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('heatingCircuits')" class="config-section col-xl-4 col-md-6 col-12 heating-circuits">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_HEATINGCIRCUITS')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">


                        <form [formGroup]="heatingCircuitsForm">
                            <div class="form-group row">
                                <div class="col-1"></div>
                                <label class="col-4 col-md-11" for="heatingCircuitsNumber">
                                   <!-- <span>Heating Circuits</span>-->
                                </label>

                                <div class="col-7 col-md-9">
                                    <select  #selectElement class="form-control btn float-left" name="heatingCircuitsNumber" formControlName="heatingCircuitsNumber" [attr.disabled]='isDisabled("heatingCircuits","")' [ngStyle]="{'width':'auto'}">
                                        <option *ngFor='let num of [1,2,3,4,5,6,7,8,9]' [value]="num">{{num}} <span *ngIf="num == 1">{{getTranslator().tr('CONFIG_UI_SOLAR_HEATINGCIRCUIT_SINGULAR')}}</span><span *ngIf="num != 1">{{getTranslator().tr('CONFIG_UI_SOLAR_HEATINGCIRCUIT_PLURAL')}}</span>
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>

        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('bufferCylinder')" class="config-section col-xl-4 col-md-6 col-12 buffer-cylinder">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_BUFFER_CYLINDER')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9 col-md-9">


                        <form [formGroup]="bufferCylinderForm">

                            <div class="form-row" *ngIf="subModuleAvailable('bufferCylinder','no')">
                                <div class="col-1"><input type="radio" value="no" formControlName="bufferCylinder" [attr.disabled]='isDisabled("bufferCylinder","no")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("bufferCylinder","no")}'>{{getTranslator().tr('CONFIG_UI_NO')}}</label>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('bufferCylinder','yes')">
                                <div class="col-1"><input type="radio" value="yes" formControlName="bufferCylinder" [attr.disabled]='isDisabled("bufferCylinder","yes")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("bufferCylinder","yes")}'>{{getTranslator().tr('CONFIG_UI_YES')}}</label>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('bufferCylinder','allStor')">
                                <div class="col-1"><input type="radio" value="allStor" formControlName="bufferCylinder" [attr.disabled]='isDisabled("bufferCylinder","allStor")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("bufferCylinder","allStor")}'>allSTOR</label>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>

        <div *ngIf="(!isCustomerVersion()) && moduleAvailable('solarSystem')" class="config-section col-xl-4 col-md-6 col-12 solar-system">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_SOLARSYSTEM')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">


                        <form [formGroup]="solarSystemForm">

                            <div class="form-row" *ngIf="subModuleAvailable('solarSystem','no')">
                                <div class="col-1"><input type="radio" value="no" formControlName="solarSystem" [attr.disabled]='isDisabled("solarSystem","no")'></div>
                                <label class="col-4 col-md-6" [ngClass]='{"disabled":isDisabled("solarSystem","no")}'>{{getTranslator().tr('CONFIG_UI_NO')}}</label>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('solarSystem','one')">
                                <div class="col-1"><input type="radio" value="one" formControlName="solarSystem" [attr.disabled]='isDisabled("solarSystem","one")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("solarSystem","one")}'>{{getTranslator().tr('CONFIG_UI_SOLAR_CYLINDER_SINGULAR')}}</label>
                            </div>

                            <div class="form-row" *ngIf="subModuleAvailable('solarSystem','two')">
                                <div class="col-1"><input type="radio" value="two" formControlName="solarSystem" [attr.disabled]='isDisabled("solarSystem","two")'></div>
                                <label class="col-11" [ngClass]='{"disabled":isDisabled("solarSystem","two")}'>{{getTranslator().tr('CONFIG_UI_SOLAR_CYLINDER_PLURAL')}}</label>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
            <hr/>
        </div>


        <div class="container-fluid">
            <div class="row config-footer p-3">
                <div class="col-12">

                    <form [formGroup]="languageForm">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-9">
                                </div>
                                <div class="col-3 p-1">
                                    
                                </div>
                                <div class="col-12 col-md-4">
                                    
                                    <select class="float-left btn m-1" formControlName="language">
                                        <option *ngFor='let lang of availableLanguages' [value]="lang.getCountryCode()">{{lang.getLanguageNameNative()}}</option>
                                    </select>
                                         
                                </div>
                                
                                    
                                <div class="col-12 col-md-8 p-1">
                                    <button (click)="startSimulation($event)"  class="m-1 float-right btn btn-small btn-info bg-vaillant-green" [attr.disabled]='isDisabled("startButton","simulation")'>{{getTranslator().tr('BUTTON_START_SIMULATION_CAPTION')}}</button>
                                    <button *ngIf="(!isCustomerVersion())" (click)="startInstallation($event)" class="m-1 float-right btn btn-small btn-info bg-vaillant-green" [attr.disabled]='isDisabled("startButton","installation")'>{{getTranslator().tr('BUTTON_START_INSTALLATION_CAPTION')}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    </div>
</div>